var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DefaultApiFactory } from "@/apis/transaction-management";
import InfinityTable from "@/components/Infinitytable";
import { LocalStorageKeys } from "@/constants/localStorage";
import useApi from "@/hooks/useApi";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { columns } from "./RoundTransactionTable.columns";
import { GlobalStyle } from "./RoundTransactionTable.style";
var RoundTransactionTable = function (_a) {
    var gameId = _a.gameId;
    var t = useTranslation().t;
    var _b = useApi({
        asyncFunction: DefaultApiFactory().getTransactionsByGameId,
    }), callTransactionListByGameId = _b.call, data = _b.data, loading = _b.loading;
    var sortTransactionsByTimestamp = function (transactions) {
        if (transactions === void 0) { transactions = []; }
        return __spreadArray([], transactions, true).sort(function (a, b) { return (Number(b.timestamp) || 0) - (Number(a.timestamp) || 0); });
    };
    useEffect(function () {
        callTransactionListByGameId({
            gameId: gameId,
            tenant: localStorage.getItem(LocalStorageKeys.TENANT),
            isAsc: true,
        });
    }, []);
    var getClassName = function (record) {
        var _a, _b, _c;
        console.log(record, "record");
        var winnerCount = (_c = (_b = (_a = record === null || record === void 0 ? void 0 : record.game) === null || _a === void 0 ? void 0 : _a.winnerResult) === null || _b === void 0 ? void 0 : _b.winnersCount) !== null && _c !== void 0 ? _c : 0;
        return winnerCount > 0 ? "winner-row" : "";
    };
    return (_jsx(GlobalStyle, { children: _jsx(InfinityTable, { columns: columns(t), dataSource: sortTransactionsByTimestamp(data === null || data === void 0 ? void 0 : data.data), loading: loading, rowClassName: getClassName }) }));
};
export default RoundTransactionTable;
